export default __webpack_public_path__ + "static/media/sticker-Q.5919dae6.png";